import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CookieConsent from "react-cookie-consent";
import Header from './components/Header';
import Footer from './components/Footer';

// Example pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import Features from './pages/Features';
import PrivacyPage from './pages/PrivacyPolicy';
import TermsPage from './pages/Terms';
import BlogPage from './pages/BlogPost';
import BlogListPage from './pages/BlogListPage';

function App() {
  return (
    <Router>
      <div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/features" element={<Features />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:id" element={<BlogPage />} />
        </Routes>
        <Footer />
        
        {/* Cookie Consent Banner (Black & White) */}
        <CookieConsent
          location="bottom"
          buttonText="Accept"
          declineButtonText="Decline"
          enableDeclineButton
          cookieName="userConsent"
          style={{ background: "#000", color: "#fff" }}
          buttonStyle={{ color: "#000", background: "#fff", fontSize: "14px", borderRadius: "5px", padding: "8px 12px", border: "1px solid #fff" }}
          declineButtonStyle={{ color: "#fff", background: "#444", fontSize: "14px", borderRadius: "5px", padding: "8px 12px", border: "1px solid #fff" }}
          expires={150}
        >
          This website uses cookies.{" "}
          <a href="/privacy-policy" style={{ color: "#fff", textDecoration: "underline" }}>
            Learn more
          </a>
        </CookieConsent>
      </div>
    </Router>
  );
}

export default App;
